import { render } from "./GrupoTelasInstitucionalView.vue?vue&type=template&id=fad2d620"
import script from "./GrupoTelasInstitucionalView.vue?vue&type=script&lang=js"
export * from "./GrupoTelasInstitucionalView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__